export default "__VITE_ASSET__CM2ILh_S__"